import { render } from "./App.vue?vue&type=template&id=29528bf2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=29528bf2&lang=css"

import exportComponent from "/Users/zur/Web/repos/squares/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__